import React from 'react'

import { OrdersList } from 'common/components/OrdersList'
import { PsqlColumn } from 'common/components/PsqlTable/psql_table_provider'
import { formatDateString } from 'common/helpers/formatters'

import { IndexOrderRecord } from 'vendor/server/orders'

import { Cell } from '../components/cell'

interface Props {
  statusColumn: {
    getNotificationsCount: (id: string) => number
  }
  actionsColumn: {
    disabled: boolean
  }
}

export function columnsFactory(props: Props): Array<PsqlColumn<IndexOrderRecord>> {
  const { statusColumn, actionsColumn } = props

  return [
    {
      Header: 'Status',
      accessor: 'state',
      width: 176,
      sortBy: 'state',
      Cell: ({ row }) => (
        <OrdersList.Cell.Status
          state={row.original.state}
          subState={row.original.sub_state}
          deliveries={row.original.deliveries}
          hasOpenDeliveryIssue={row.original.has_open_delivery_issue}
          leadTimeCutoffDateTimestamp={row.original.lead_time_cutoff_date_timestamp}
          notificationsCount={statusColumn.getNotificationsCount(row.original.order_id)}
        />
      ),
    },
    {
      Header: 'Customer',
      accessor: 'company_name',
      Cell: OrdersList.Cell.FormattedText,
      ellipsis: true,
    },
    {
      Header: 'Order',
      accessor: 'order_number',
      sortBy: 'order',
      width: 400,
      Cell: ({ row }) => (
        <Cell.OrderNumber
          orderName={row?.original?.name}
          orderNumber={row?.original?.order_number}
          orderId={row?.original?.order_id}
          orderPackageId={row?.original?.order_package_id}
          state={row?.original?.state}
          subState={row?.original?.sub_state}
          basePath="/vendor"
        />
      ),
    },
    {
      Header: 'Project',
      ellipsis: true,
      Cell: ({ row, column }) => (
        <OrdersList.Cell.FormattedText
          column={column}
          value={`${row.original.project_number ? `${row.original.project_number}: ` : ''}${row.original.project_name}`}
        />
      ),
    },
    {
      Header: 'Last Action',
      id: 'last_action',
      accessor: 'last_action',
      width: 250,
      Cell: (props) => (
        <OrdersList.Cell.LastAction
          lastAction={props.row.original.last_action}
          currentType={['VendorUser', 'CompanyVendorContact']}
        />
      ),
    },
    {
      Header: 'Expiration Date',
      accessor: 'quote_scheduled_to_expire_at',
      width: 160,
      Cell: ({ row, value }) => <OrdersList.Cell.ExpirationQuote date={value} state={row?.original?.state} />,
    },
    {
      Header: 'Created at',
      id: 'created_at',
      accessor: ({ created_at }) => formatDateString(created_at),
      width: 160,
      sortBy: 'created',
    },
    {
      Header: 'Ordered By',
      id: 'ordered_by',
      width: 250,
      Cell: ({ row: { original: order } }) => (
        <OrdersList.Cell.OrderedBy state={order.state} orderedBy={order.ordered_by_name} quickCreated={false} />
      ),
    },
    {
      Header: 'Watchers',
      accessor: 'watcher_user_names',
      id: 'watchers',
      width: 250,
      Cell: (props) => <OrdersList.Cell.Tags tags={props.row.original.watcher_user_names} />,
    },
    {
      Header: 'Delivery Info',
      id: 'delivery_info',
      width: 350,
      ellipsis: true,
      Cell: ({ row }) => <OrdersList.Cell.DeliveryInfo deliveries={row?.original?.deliveries} />,
    },
    {
      id: 'Actions',
      Header: ' ',
      Cell: ({ row }) => <Cell.Actions orderId={row.original.order_id} />,
      disabled: actionsColumn.disabled,
      ellipsis: false,
    },
  ]
}
